/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppLayout from "../App";
import configDB from "../data/customizer/config";
import PrivateRoute from "./private-route";
import Signin from "../auth/signin";
import Adminsignin from "../pages/admin/admsignin";
import Error400 from "../pages/errors/error400";
import Error404 from "../pages/errors/error404";
import Error500 from "../pages/errors/error500";
import Maintenance from "../pages/maintenance";
import Register from "../pages/authentication/register";
import Forgetpwd from "../pages/authentication/forgetpwd";
import Comingsoon from "../pages/comingSoon/comingsoon";
import ComingsoonVideo from "../pages/comingSoon/comingsoonVideo";
import ComingsoonImg from "../pages/comingSoon/comingsoonImg";
import { routes } from "./layouts-routes";
import ValetCompanies from "../pages/valet/ValetCompany";
import ValetUsers from "../pages/users/ValetUsers";
import ActiveProcesses from "../pages/users/ActiveProcesses";
import Valet from "../pages/valet/Valet";
import ValetActiveProcesses from "../pages/valet/ValetActiveProcesses";
import ValetReports from "../pages/valet/ValetReports";
import Notification from "../component/notification/notification";
import LandingPage from "../component/general/dashboard/landingpage";
import NotificationIziPay from "../pages/notifications/notificationIziPay";
import PaymentIziPay from "../pages/notifications/paymentIziPay";
import RequestCar from "../pages/users/RequestCar";

const MainRoutes = () => {
  const [currentUser, setCurrentUser] = useState(false);
  useEffect(() => {
    const abortController = new AbortController();
    const color = localStorage.getItem("color");
    const layout = localStorage.getItem("layout_version") || configDB.data.color.layout_version;
    document.body.classList.add(layout);
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    setCurrentUser(localStorage.getItem("userType"));
    document.getElementById("color").setAttribute("href", `${process.env.REACT_APP_PUBLIC_URL}/assets/css/${color}.css`);
    return function cleanup() {
      abortController.abort();
    };
  }, []);

  return (
    <>
      <Routes>
          {routes.map(({ path, Component }, i) => (
            <Route element={<AppLayout />} key={i}>
              <Route path={path} element={Component} />
            </Route>
          ))}
        <Route exact path={`${process.env.REACT_APP_PUBLIC_URL}/login`} element={<Signin />} />
        <Route exact path={`${process.env.REACT_APP_PUBLIC_URL}/admlogin`} element={<Adminsignin />} />
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/error-400`} element={<Error400 />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/error-404`} element={<Error404 />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/error-500`} element={<Error500 />}></Route>

        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/maintenance`} element={<Maintenance />}></Route>

        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/register`} element={<Register />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/forget-password`} element={<Forgetpwd />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/valetcomp`} element={<ValetCompanies />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/valetuser`} element={<ValetUsers />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/users/activeprocesses`} element={<ActiveProcesses />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/valet`} element={<Valet />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/valet/activeprocesses`} element={<ValetActiveProcesses />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/valetreports`} element={<ValetReports />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/notifications`} element={<Notification />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/`} element={<LandingPage />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/comingsoon`} element={<Comingsoon />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/comingsoon-bg-image`} element={<ComingsoonImg />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/pages/comingsoon-bg-video`} element={<ComingsoonVideo />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/notifications`} element={<NotificationIziPay />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/payment-success`} element={<PaymentIziPay />}></Route>
        <Route path={`${process.env.REACT_APP_PUBLIC_URL}/requestCar/:transactionId/:valetId/:cusId/:token`} element={<RequestCar />}></Route>
      </Routes>
    </>
  );
};

export default MainRoutes;
